import { __assign } from "tslib";
import { BuildMode } from '../../boot/init';
import { objectValues } from '../../tools/utils';
import { createEndpointBuilder, INTAKE_SITE_US } from './endpointBuilder';
import { buildTags } from './tags';
export function computeTransportConfiguration(initConfiguration, buildEnv) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, buildEnv, tags);
    var intakeEndpoints = objectValues(endpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, buildEnv, intakeEndpoints, tags);
    return __assign(__assign({ isIntakeUrl: function (url) { return intakeEndpoints.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); } }, endpointBuilders), { replica: replicaConfiguration });
}
function computeEndpointBuilders(initConfiguration, buildEnv, tags) {
    if (buildEnv.buildMode === BuildMode.E2E_TEST) {
        var e2eEndpointBuilder = function (placeholder) { return ({
            build: function () { return placeholder; },
            buildIntakeUrl: function () { return placeholder; },
        }); };
        return {
            logsEndpointBuilder: e2eEndpointBuilder('<<< E2E LOGS ENDPOINT >>>'),
            rumEndpointBuilder: e2eEndpointBuilder('<<< E2E RUM ENDPOINT >>>'),
            sessionReplayEndpointBuilder: e2eEndpointBuilder('<<< E2E SESSION REPLAY ENDPOINT >>>'),
            internalMonitoringEndpointBuilder: e2eEndpointBuilder('<<< E2E INTERNAL MONITORING ENDPOINT >>>'),
        };
    }
    var endpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, buildEnv, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, buildEnv, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, buildEnv, 'sessionReplay', tags),
    };
    if (initConfiguration.internalMonitoringApiKey) {
        return __assign(__assign({}, endpointBuilders), { internalMonitoringEndpointBuilder: createEndpointBuilder(__assign(__assign({}, initConfiguration), { clientToken: initConfiguration.internalMonitoringApiKey }), buildEnv, 'logs', tags, 'browser-agent-internal-monitoring') });
    }
    return endpointBuilders;
}
function computeReplicaConfiguration(initConfiguration, buildEnv, intakeEndpoints, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = __assign(__assign({}, initConfiguration), { site: INTAKE_SITE_US, clientToken: initConfiguration.replica.clientToken });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, buildEnv, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, buildEnv, 'rum', tags),
        internalMonitoringEndpointBuilder: createEndpointBuilder(replicaConfiguration, buildEnv, 'logs', tags, 'browser-agent-internal-monitoring'),
    };
    intakeEndpoints.push.apply(intakeEndpoints, objectValues(replicaEndpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); }));
    return __assign({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map